export default function decodeHTMLEntities(text : string) {
    const parser = new DOMParser();
    const decodedText = parser.parseFromString(text.replaceAll(/\u2028/g, ''), 'text/html').body.textContent;
    return decodedText;
}